var _path, _line, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9392 3.92304L10.7876 13.4649C10.7552 13.525 10.7084 13.5757 10.6503 13.6125L7.16591 15.8389C7.13384 15.8592 7.09953 15.8745 7.0645 15.885C6.96338 15.9152 6.85372 15.9047 6.75845 15.8533C6.63036 15.7836 6.54966 15.6507 6.54772 15.5044L6.49841 11.3696C6.4975 11.3014 6.51404 11.2339 6.54648 11.1738L11.6991 1.63302C12.1721 0.755978 13.2714 0.428377 14.1478 0.90168L15.2078 1.47419C15.6325 1.70299 15.943 2.08468 16.0812 2.54735C16.2192 3.00936 16.1686 3.49816 15.9392 3.92304Z",
    fill: "#05CE88"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.25725,
    y1: 10.5713,
    x2: 11.2572,
    y2: 13.5713,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.5H1V19H16V11.5",
    stroke: "#05CE88",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreen);
export default __webpack_public_path__ + "static/media/edit-green.4194630f.svg";
export { ForwardRef as ReactComponent };